module.exports = __webpack_public_path__ + "static/media/icon_82.e894642a.svg";